import {
  type TYachtSetupField,
  type TYachtSetupFields,
} from "../yachtSetup.types";
import { type IGmdssSetupForm } from "./GmdssSetup.types";

export const mapGmdssSetup = (response: any): IGmdssSetupForm => {
  const gmdss = response?.data?.content?.data?.data?.gmdss;
  if (!gmdss) {
    return {
      epirb: [{ serial: "", exp: "" }],
      sat: [{ serial: "", exp: "" }],
      vhf: [{ serial: "", exp: "" }],
      owner: "",
      sbm: "",
    };
  }
  return {
    epirb: gmdss.epirb ?? [],
    sat: gmdss.sat ?? [],
    vhf: gmdss.vhf ?? [],
    owner: gmdss.owner ?? "",
    sbm: gmdss.sbm ?? "",
  };
};
// NOTE THAT FIELDS ARE GENERATED DYNAMICALLY FROM API AND USER CLICKS, THIS IS DATA FOR BLUEPRINT
export const gmdssSetupFields: TYachtSetupFields = [
  { line: true, label: "EPIRB" },
  { name: "epirb.0.serial", label: "EPIRB Serial Number" },
  { name: "epirb.0.exp", label: "EPIRB Battery Expiration" },
  { button: true, label: "Add EPIRB", type: "epirb.0.exp" },
  { line: true, label: "SART" },
  { name: "sat.0.serial", label: "SART Serial Number" },
  { name: "sat.0.exp", label: "SART Battery Expiration" },
  { button: true, label: "Add SART", type: "sat.0.exp" },
  { line: true, label: "VHF" },
  { name: "vhf.0.serial", label: "VHF Serial Number" },
  { name: "vhf.0.exp", label: "VHF Battery Expiration" },
  { button: true, label: "Add VHF", type: "vhf.0.exp" },
  { line: true, label: "" },
  { name: "owner", label: "Owner" },
  { name: "sbm", label: "SBM" },
];
export const getNextFieldName = (str: string): string => {
  const arrayPathMatch = str.match(/^([a-z]+)\.(\d+)\.(.+)$/);
  if (arrayPathMatch) {
    const [, prefix, indexStr, suffix] = arrayPathMatch;
    return `${prefix}.${parseInt(indexStr) + 1}.${suffix}`;
  }
  const capitalCharRegex = /([A-Z])(?!.*[A-Z])/;
  const capitalCharRegexMatch = str.match(capitalCharRegex);
  if (!capitalCharRegexMatch) return str + "A";
  else
    return str.replace(capitalCharRegex, char => {
      return String.fromCharCode(char.charCodeAt(0) + 1);
    });
};

export const getNextFieldLabel = (lastField: TYachtSetupField) => {
  if (!lastField.label) return "";
  const number = lastField.label.match(/\d+/);
  if (!number) return lastField.label + " 1";
  else
    return lastField.label.replace(/\d+/, (parseInt(number[0]) + 1).toString());
};

export const groupAndOrderDataByNumber = (
  data: IGmdssSetupForm,
): Record<string, any[]> => {
  const result: Record<string, any[]> = {};
  if (data.epirb?.length) result["epirb.0.exp"] = data.epirb;
  if (data.sat?.length) result["sat.0.exp"] = data.sat;
  if (data.vhf?.length) result["vhf.0.exp"] = data.vhf;
  return result;
};
